import cleanDeep from 'clean-deep'

import getAxiosInstance from '../../helpers/get_axios_instance'
import { parseEntityId } from '../entity'
import lrsAdapter from '../../helpers/lrs_adapter'

class IngresoMinimo {
  constructor (args = {}) {
    const {
      numero,
      cpeSucursal,
      cpeSecuencia,
      cereal,
      cerealVariedad,
      exportador,
      titular,
      remitenteComercialProductor,
      remitenteComercialVentaPrimaria,
      remitenteComercialVentaSecundaria,
      intermediario,
      corredorComprador,
      corredorVendedor,
      vendedor,
      camion
    } = args

    this.numero = numero
    this.cpeSucursal = cpeSucursal
    this.cpeSecuencia = cpeSecuencia
    this.cereal = cereal
    this.cerealVariedad = cerealVariedad
    this.exportador = exportador
    this.cuentayorden = titular
    this.remitenteComercialProductor = remitenteComercialProductor
    this.remitenteComercialVentaPrimaria = remitenteComercialVentaPrimaria
    this.remitenteComercialVentaSecundaria = remitenteComercialVentaSecundaria
    this.intermediario = intermediario
    this.corredorComprador = corredorComprador
    this.corredorVendedor = corredorVendedor
    this.vendedor = vendedor
    this.camion = camion
  };

  save () {
    const axios = getAxiosInstance()
    const ingresoMinimoData = this.getDataWithApiFormat()
    const promise = axios.post(`carta_de_porte_automotor_ingreso`,
      cleanDeep({ valores: ingresoMinimoData }))

    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
  };

  getDataWithApiFormat () {
    return {
      ...this,
      exportador: parseEntityId(this.exportador),
      cuentayorden: parseEntityId(this.cuentayorden),
      remitenteComercialProductor: parseEntityId(this.remitenteComercialProductor),
      remitenteComercialVentaPrimaria: parseEntityId(this.remitenteComercialVentaPrimaria),
      remitenteComercialVentaSecundaria: parseEntityId(this.remitenteComercialVentaSecundaria),
      intermediario: parseEntityId(this.intermediario),
      corredorComprador: parseEntityId(this.corredorComprador),
      corredorVendedor: parseEntityId(this.corredorVendedor),
      vendedor: parseEntityId(this.vendedor),
      camion: this.camion.toUpperCase()
    }
  };
}

export default IngresoMinimo
